import { render, staticRenderFns } from "./SurgeryList.vue?vue&type=template&id=0eba45cd&scoped=true"
import script from "./SurgeryList.vue?vue&type=script&lang=js"
export * from "./SurgeryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eba45cd",
  null
  
)

export default component.exports